<div class="gains-date-picker">
  <gains-input-title *ngIf="label" [label]="label" [required]="required"></gains-input-title>

  <div [ngClass]="{ 'error-input': error }">
    <!-- Date picker. -->
    <nz-time-picker
      (nzOnOpenChange)="this.onPanelChanged($event)"
      (ngModelChange)="onValueChange($event)"
      [formControl]="internalFormControl"
      nzUse12Hours
      [nzFormat]="this.format"
    ></nz-time-picker>
  </div>

  <div class="error-message" *ngFor="let message of errorMessagesToDisplay">
    <svg-icon src="assets/icons/exclamation-circle.svg"></svg-icon>
    <span>{{ message }}</span>
  </div>
</div>
